<div class="item tw-border b-{{ getTrendColor(user.trend) }} tw-border-solid" [elementDataTest]="user.id">
    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
        <div class="tw-flex tw-items-center">
            <div
                class="tw-text-center tw-relative tw-inline-flex tw-justify-center tw-items-center tw-rounded-full tw-border tw-border-solid tw-box-content tw-mr-3 tw-font-bold"
                [ngClass]="['b-' + getTrendColor(user.trend), user.rank > 99 ? 'tw-size-8.5' : 'tw-size-6.5']"
            >
                <span [ngClass]="['tw-text-' + getTrendColor(user.trend), user.rank > 99 ? 'tw-font-xs' : 'tw-font-sm']">{{ user.rank }}</span>
            </div>
            <div class="tw-px-0">
                <span class="tw-text-black tw-text-sm tw-font-bold">{{ userFullName }}</span>
            </div>
        </div>
        <div class="tw-flex tw-items-center">
            <div>
                <span class="tw-text-black tw-text-xs">{{ user.watched.seconds | time: { type: 'letter', round: 'down' } }}</span>
            </div>
            <div class="tw-ml-2">
                <div [ngSwitch]="user.trend">
                    <div *ngSwitchCase="'success'">
                        <app-icon name="arrow-up" class="tw-fill-success tw-w-4 tw-h-4"></app-icon>
                    </div>
                    <div *ngSwitchCase="'muted'">
                        <div class="tw-size-4 tw-rounded-full tw-bg-black-10"></div>
                    </div>
                    <div *ngSwitchCase="'danger'">
                        <app-icon name="arrow-down" class="tw-fill-danger tw-w-4 tw-h-4"></app-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
